import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore'

import {
    SAVE_LAST_STAGE_INDEX,
    SAVE_LAST_SCORE,
    SAVE_SCORES,
    UPDATE_SCORE,
    SAVE_LAST_PACKAGE_INDEX,
    SAVE_SENTENCES,
    SAVE_WORDS,
} from './actions'

const initialState = {
    lastStageIndex: 0,
    lastScore: -2,
    lastPackageIndex: -1,
    scores: {},
    words: {},
    sentences: {},
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_LAST_STAGE_INDEX:
            return {
                ...state,
                lastStageIndex: action.index
            }

        case SAVE_LAST_PACKAGE_INDEX:
            return {
                ...state,
                lastPackageIndex: action.index
            }

        case SAVE_LAST_SCORE:
            return {
                ...state,
                lastScore: action.score
            }

        case SAVE_SCORES:
            return {
                ...state,
                scores: action.scores
            }

        case SAVE_WORDS:
            return {
                ...state,
                words: action.words
            }

        case SAVE_SENTENCES:
            return {
                ...state,
                sentences: action.sentences
            }

        case UPDATE_SCORE:
            const updatedScores = { ...state.scores }
            if (updatedScores[action.lessonId] === undefined) {
                updatedScores[action.lessonId] = {}
            }
            updatedScores[action.lessonId][action.stageIndex] = action.score;

            firebase.firestore().collection('users')
                .doc(firebase.auth().currentUser.uid)
                .set({
                    scores: updatedScores,
                }, { merge: true })
            return {
                ...state,
                scores: updatedScores,
                lastScore: -2,
            }

        default: return state;
    }
}

export default reducer;
